import { render } from "./ResendPasswordView.vue?vue&type=template&id=5bbcf504&scoped=true&ts=true"
import script from "./ResendPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResendPasswordView.vue?vue&type=script&lang=ts"

import "./ResendPasswordView.vue?vue&type=style&index=0&id=5bbcf504&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbcf504"]])

export default __exports__